import type { AnimationControls, Transition, Variants } from 'framer-motion';
import { motion } from 'framer-motion';

import { type AnimatedIconHandle, withAnimatedIcon } from './withAnimatedIcon';

type PanelLeftOpenIconRenderProps = {
  controls: AnimationControls;
  size: number;
};

const defaultTransition: Transition = {
  times: [0, 0.4, 1],
  duration: 0.5,
};

const pathVariants: Variants = {
  normal: { x: 0 },
  animate: { x: [0, 1.5, 0] },
};

const PanelLeftOpenIconRender = ({ controls, size }: PanelLeftOpenIconRenderProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect width="18" height="18" x="3" y="3" rx="2" />
    <path d="M9 3v18" />
    <motion.path
      transition={defaultTransition}
      variants={pathVariants}
      animate={controls}
      d="m14 9 3 3-3 3"
    />
  </svg>
);

export type PanelLeftOpenIconHandle = AnimatedIconHandle;

export const PanelLeftOpenIcon = withAnimatedIcon(PanelLeftOpenIconRender, 'PanelLeftOpenIcon');
